import { render, staticRenderFns } from "./VatDeclarationView.vue?vue&type=template&id=6664e98a&"
import script from "./VatDeclarationView.vue?vue&type=script&lang=js&"
export * from "./VatDeclarationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports